export const PROFILE_URL = '/profile';
export const HOMEPAGE_URL = '/home';
export const DIRECTORY_URL = '/search';
export const ORG_CHART_URL = '/orgchart';
